import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed } from '@angular/core';
import { FileUpload, SceneConfig, ScenePath } from '@models';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';

const DEFAULT_SCENE = ScenePath.Anatomo;

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
declare const require: any;

type SceneState = {
  selectedScene: ScenePath;
  videoUpload: FileUpload;
  taskListCompleted: boolean;
  allTasksSkipped: boolean;
  sceneConfig: SceneConfig;
};

const initialState: SceneState = {
  selectedScene: DEFAULT_SCENE,
  videoUpload: {} as FileUpload,
  taskListCompleted: false,
  allTasksSkipped: false,
  sceneConfig: {} as SceneConfig,
};

export const SceneStore = signalStore(
  { providedIn: 'root' },
  withDevtools('scene'),
  withState(initialState),
  withComputed(({ selectedScene }) => {
    return {
      path: computed(() => selectedScene()),
    };
  }),
  withMethods((store) => ({
    selectScene(selectedScene: ScenePath): void {
      patchState(
        store,
        (state): SceneState => ({
          ...state,
          selectedScene,
        }),
      );
    },
    updateTaskstate(
      taskListCompleted: boolean,
      allTasksSkipped: boolean,
    ): void {
      patchState(
        store,
        (state): SceneState => ({
          ...state,
          taskListCompleted,
          allTasksSkipped,
        }),
      );
    },
    setUploadVideo(videoUpload: FileUpload): void {
      patchState(
        store,
        (state): SceneState => ({
          ...state,
          videoUpload,
        }),
      );
    },
  })),
);

export const createPath = (
  file: string,
  path: string,
  scenePath: string,
): string => {
  const paths = file.split('@shared/');
  if (paths.length > 1) {
    path = 'shared/' + paths[1];
  } else {
    path = scenePath + path + file;
  }
  return path;
};
